import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";

const SpecificationTable = ({ specs }) => {
  return (
    <Box m={"20px 0px"}>
      <Box>
        <Typography variant="h6" gutterBottom fontWeight={"bold"}>
          {specs?.heading}
        </Typography>
      </Box>
      <TableContainer>
        <Table>
          <TableBody>
            {specs?.rows?.map((el) => (
              <TableRow key={el?.label}>
                <TableCell
                  component="th"
                  scope="row"
                  style={{ backgroundColor: "#EFF2F2", whiteSpace: "normal" }}
                >
                  <Typography>{el?.field}</Typography>
                </TableCell>
                <TableCell style={{ whiteSpace: "normal" }}>
                  <Typography>{el?.value}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SpecificationTable;
